import {useCallback, useEffect} from 'react';

export default function useBeforeUnloadConfirmation(enable: boolean) {
    const onBeforeUnload = useCallback(event => {
        if (enable) {
            event.preventDefault();
            event.returnValue = '';
        }
    }, [enable]);

    useEffect(() => {
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, [onBeforeUnload]);
}
